import { render, staticRenderFns } from "./genre.vue?vue&type=template&id=61e4924b&scoped=true"
import script from "./genre.vue?vue&type=script&setup=true&lang=js"
export * from "./genre.vue?vue&type=script&setup=true&lang=js"
import style0 from "./genre.vue?vue&type=style&index=0&id=61e4924b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e4924b",
  null
  
)

export default component.exports